module.exports = __webpack_public_path__ + "static/media/venus-double.5a2fd0ac.svg";